/**
 * Extracts a user-facing message from a mutation/query error, falling back to a
 * provided default when the backend didn't supply one. Use at the call site
 * (page/component) to toast the backend message — hooks don't toast.
 *
 * @example
 * mutate(vars, {
 *   onError: (e) => toast.error(getApiErrorMessage(e, "Failed to save")),
 * });
 */
export const getApiErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  const message = error instanceof Error ? error.message : "";
  return message.trim() ? message : fallback;
};
